import { createTheme, ThemeProvider } from '@mui/material';
import Chat from '../Chat';
import ClassicBoard from './ClassicBoard';
import './classic.css';

// The classic look ran on Material UI's stock theme; the felt-table theme
// wraps the rest of the app, so it is swapped back out for these pages.
const classicTheme = createTheme();

const Classic = () => (
    <ThemeProvider theme={classicTheme}>
        <Chat classic />
        <ClassicBoard />
    </ThemeProvider>
);

export default Classic;
